// Small, self-contained CSV helpers - deliberately not a library, just
// proper escaping + a browser download, per the "keep it simple" guidance.

// Quotes a field only when it actually needs it (contains a comma, a
// double quote, or a newline), doubling any internal quotes per the CSV
// spec - never naive string concatenation.
function escapeCsvField(value) {
  const str = value === null || value === undefined ? '' : String(value);
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

// headers: string[]; rows: array of arrays (same length as headers).
// CRLF row separator for maximum spreadsheet-software compatibility.
export function buildCsv(headers, rows) {
  const lines = [headers, ...rows].map((row) => row.map(escapeCsvField).join(','));
  return lines.join('\r\n') + '\r\n';
}

// Keeps only characters that are safe across Windows/macOS/Linux
// filesystems - everything else (spaces, accents, slashes, etc.) becomes
// an underscore.
export function sanitizeFilename(name) {
  return name.replace(/[^a-zA-Z0-9_\-.]/g, '_');
}

// UTF-8 BOM prefix (U+FEFF, written via fromCharCode to avoid embedding an
// invisible literal in source) so Excel opens accented/°-containing CSVs
// with the correct encoding instead of guessing wrong and mangling them.
export function downloadCsv(filename, csvText) {
  const BOM = String.fromCharCode(0xFEFF);
  const blob = new Blob([BOM + csvText], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
